import { z } from "zod/v4";

import { BaseNodeExecutionResultSchema } from "../node-execution-result";

import {
  BaseNodeDefinitionConfigSchema,
  BaseNodeDefinitionSchema,
} from "./base-node";

// Configuration schema for inject-context node
export const InjectContextNodeConfigSchema =
  BaseNodeDefinitionConfigSchema.extend({
    sources: z.record(z.string(), z.array(z.string())), // { category: string[] }
    overwrite: z.boolean().optional().default(false), // Replace or merge with existing context
  });

// Node definition schema
export const InjectContextNodeDefinitionSchema =
  BaseNodeDefinitionSchema.extend({
    type: z.literal("inject-context"),
    config: InjectContextNodeConfigSchema,
  });

// Result schema
export const InjectContextNodeResultSchema =
  BaseNodeExecutionResultSchema.extend({
    type: z.literal("inject-context"),
    contextLoaded: z
      .object({
        categories: z.array(z.string()),
        filesCount: z.number(),
      })
      .optional(),
  });

// TypeScript types inferred from Zod schemas
export type InjectContextNodeConfig = z.infer<
  typeof InjectContextNodeConfigSchema
>;
export type InjectContextNodeDefinition = z.infer<
  typeof InjectContextNodeDefinitionSchema
>;
export type InjectContextNodeResult = z.infer<
  typeof InjectContextNodeResultSchema
>;
